var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMobileIn(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 118,
    height: 109,
    viewBox: "0 0 118 109",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_522_210)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 118,
    height: 108.229,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.377 73.5997H62.945C62.1863 73.5997 61.5688 72.9781 61.5688 72.2142V9.99187C61.5688 9.22802 62.1863 8.60645 62.945 8.60645H105.377C106.136 8.60645 106.753 9.22778 106.753 9.99187V72.214C106.753 72.9781 106.136 73.5997 105.377 73.5997ZM62.945 8.66553C62.2184 8.66553 61.6275 9.26064 61.6275 9.99187V72.214C61.6275 72.9455 62.2187 73.5404 62.945 73.5404H105.377C106.104 73.5404 106.695 72.9452 106.695 72.214V9.99187C106.695 9.26064 106.104 8.66553 105.377 8.66553H62.945Z",
    fill: "#F1F5F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.4475 73.5997H14.0153C13.2566 73.5997 12.6392 72.9781 12.6392 72.2142V9.99187C12.6392 9.22802 13.2563 8.60645 14.0153 8.60645H56.4475C57.2063 8.60645 57.8237 9.22778 57.8237 9.99187V72.214C57.8239 72.9781 57.2065 73.5997 56.4475 73.5997ZM14.0153 8.66553C13.289 8.66553 12.6979 9.26064 12.6979 9.99187V72.214C12.6979 72.9455 13.289 73.5404 14.0153 73.5404H56.4475C57.1741 73.5404 57.765 72.9452 57.765 72.214V9.99187C57.765 9.26064 57.1739 8.66553 56.4475 8.66553H14.0153Z",
    fill: "#F1F5F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.543 88.0326H1.1626V88.0913H118.543V88.0326Z",
    fill: "#DBD9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.5216 14.6078H50.9332C51.1276 14.6078 51.2854 14.449 51.2854 14.2533V12.5689C51.2854 12.3732 51.1276 12.2144 50.9332 12.2144H43.5216C43.327 12.2144 43.1694 12.3732 43.1694 12.5689V14.2533C43.1694 14.449 43.327 14.6078 43.5216 14.6078Z",
    fill: "#F1F5F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.0943 17.661H46.506C46.7004 17.661 46.8581 17.5022 46.8581 17.3065V15.6221C46.8581 15.4264 46.7004 15.2676 46.506 15.2676H39.0943C38.8999 15.2676 38.7422 15.4264 38.7422 15.6221V17.3065C38.7422 17.5024 38.8999 17.661 39.0943 17.661Z",
    fill: "#F1F5F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.7418 50.5089H16.3302C16.1358 50.5089 15.978 50.3501 15.978 50.1544V48.47C15.978 48.2743 16.1358 48.1155 16.3302 48.1155H23.7418C23.9362 48.1155 24.094 48.2743 24.094 48.47V50.1544C24.094 50.3503 23.9362 50.5089 23.7418 50.5089Z",
    fill: "#F1F5F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.1681 53.561H20.7564C20.5621 53.561 20.4043 53.4022 20.4043 53.2065V51.5221C20.4043 51.3264 20.5621 51.1676 20.7564 51.1676H28.1681C28.3625 51.1676 28.5202 51.3264 28.5202 51.5221V53.2065C28.5202 53.4024 28.3625 53.561 28.1681 53.561Z",
    fill: "#F1F5F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.17 52.9217H87.7584C87.564 52.9217 87.4062 52.7629 87.4062 52.5672V50.8828C87.4062 50.6869 87.564 50.5283 87.7584 50.5283H95.17C95.3644 50.5283 95.5222 50.6869 95.5222 50.8828V52.5672C95.5222 52.7629 95.3647 52.9217 95.17 52.9217Z",
    fill: "#F1F5F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.025 52.9217H96.6134C96.419 52.9217 96.2612 52.7629 96.2612 52.5672V50.8828C96.2612 50.6869 96.419 50.5283 96.6134 50.5283H104.025C104.22 50.5283 104.377 50.6869 104.377 50.8828V52.5672C104.377 52.7629 104.22 52.9217 104.025 52.9217Z",
    fill: "#F1F5F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.5958 55.9741H92.1842C91.9898 55.9741 91.832 55.8153 91.832 55.6196V53.9352C91.832 53.7395 91.9898 53.5807 92.1842 53.5807H99.5958C99.7902 53.5807 99.948 53.7395 99.948 53.9352V55.6196C99.948 55.8153 99.7904 55.9741 99.5958 55.9741Z",
    fill: "#F1F5F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.407 67.7156H99.9395V88.0324H108.407V67.7156Z",
    fill: "#E2E8F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.926 67.7155H81.7446V88.0322H101.926V67.7155Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.3606 67.7156H90.8672V87.9733H93.3606V67.7156Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.8746 67.7153H30.4072V88.0321H38.8746V67.7153Z",
    fill: "#E2E8F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.3929 67.7151H12.2119V88.0319H32.3929V67.7151Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.8279 67.7153H21.3345V87.973H23.8279V67.7153Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.7452 78.5229H73.2778V88.0331H81.7452V78.5229Z",
    fill: "#E2E8F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.2645 78.5227H55.0835V88.0328H75.2645V78.5227Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.6995 78.5229H64.2061V88.0054H66.6995V78.5229Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.8336 58.2058H34.3662V67.7159H42.8336V58.2058Z",
    fill: "#E2E8F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.3519 58.2059H16.1709V67.7161H36.3519V58.2059Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.7869 58.2058H25.2935V67.6883H27.7869V58.2058Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.5408 13.16H65.9897V31.8359H84.5408V13.16Z",
    fill: "#E2E8F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.6016 30.8909V14.1057L66.9288 14.1057V30.8909L83.6016 30.8909Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.1479 27.079C74.1479 27.079 77.2095 20.76 83.6018 20.6333V30.891H75.2654L74.1479 27.079Z",
    fill: "#F1F5F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.9292 25.3044C66.9292 25.3044 69.6822 23.8514 72.4804 24.918C75.994 26.2573 78.0315 30.8905 78.0315 30.8905H66.9292V25.3044Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.6486 22.3875C74.2732 22.3875 75.5902 21.0617 75.5902 19.4262C75.5902 17.7907 74.2732 16.4648 72.6486 16.4648C71.024 16.4648 69.707 17.7907 69.707 19.4262C69.707 21.0617 71.024 22.3875 72.6486 22.3875Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.7519 13.16H15.4766V44.8803H31.7519V13.16Z",
    fill: "#E2E8F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.813 43.9352L30.813 14.1057L16.4158 14.1057L16.4158 43.9352H30.813Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.401 26.3091C23.0256 26.3091 24.3426 24.9832 24.3426 23.3477C24.3426 21.7122 23.0256 20.3864 21.401 20.3864C19.7765 20.3864 18.4595 21.7122 18.4595 23.3477C18.4595 24.9832 19.7765 26.3091 21.401 26.3091Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.1074 43.9344C19.1074 43.9344 22.7512 26.2962 30.8131 24.7125V43.9344H23.6146H19.1074Z",
    fill: "#F1F5F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.416 33.4667C16.416 33.4667 18.2709 31.6663 21.2094 32.7425C26.7314 34.7652 29.8136 43.9345 29.8136 43.9345H16.416V33.4667Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.4939 27.0019C99.1877 26.6663 101.101 24.1958 100.768 21.4839C100.435 18.7719 97.9806 16.8455 95.2868 17.1811C92.593 17.5167 90.6794 19.9872 91.0127 22.6991C91.3461 25.4111 93.8001 27.3375 96.4939 27.0019Z",
    fill: "#DBD9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.305 23.1328C100.875 20.6818 99.3631 18.2298 96.9284 17.6561C94.4938 17.0824 92.0582 18.6043 91.4883 21.0553C90.9185 23.5063 92.4302 25.9583 94.8648 26.532C97.2995 27.1057 99.7351 25.5838 100.305 23.1328Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.9039 17.9487H95.7344V18.8993H95.9039V17.9487Z",
    fill: "#DBD9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.9053 25.2644H95.7358V26.215H95.9053V25.2644Z",
    fill: "#DBD9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.6556 21.9966H91.7114V22.1672H92.6556V21.9966Z",
    fill: "#DBD9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.9213 21.9967H98.9771V22.1673H99.9213V21.9967Z",
    fill: "#DBD9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.6634 19.1032L97.9956 19.7753L98.1154 19.8959L98.7832 19.2239L98.6634 19.1032Z",
    fill: "#DBD9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.5233 24.2674L92.856 24.9398L92.9759 25.0604L93.6432 24.388L93.5233 24.2674Z",
    fill: "#DBD9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.9816 19.1019L92.8618 19.2225L93.5296 19.8946L93.6494 19.7739L92.9816 19.1019Z",
    fill: "#DBD9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.1155 24.2736L97.9956 24.3943L98.6632 25.0665L98.783 24.9459L98.1155 24.2736Z",
    fill: "#DBD9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.792 21.967L95.7388 22.1031L97.3398 22.7378L97.393 22.6017L95.792 21.967Z",
    fill: "#DBD9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.8896 22.1556H93.249V22.0093H95.7443V19.9458H95.8896V22.1556Z",
    fill: "#DBD9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.956 98.3822C110.956 99.209 88.2804 99.8792 60.3088 99.8792C32.3372 99.8792 9.66162 99.209 9.66162 98.3822C9.66162 97.5555 32.3372 96.8853 60.3088 96.8853C88.2804 96.8853 110.956 97.5555 110.956 98.3822Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.9585 40.24L78.4124 44.2616H59.0896L55.314 40.24H73.9585Z",
    fill: "#11274B"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M73.9585 40.24L78.4124 44.2616H59.0896L55.314 40.24H73.9585Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.9667 40.2399H55.3135V59.0186H73.9667V40.2399Z",
    fill: "#11274B"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M73.9667 40.2399H55.3135V59.0186H73.9667V40.2399Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.9745 40.24H49.3213V59.0187H67.9745V40.24Z",
    fill: "#11274B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.3301 40.2401L44.8765 44.2617H64.199L67.9747 40.2401H49.3301Z",
    fill: "#11274B"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M49.3301 40.2401L44.8765 44.2617H64.199L67.9747 40.2401H49.3301Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.9534 46.7103C60.6923 46.7103 61.8731 47.7424 61.8731 49.4405C61.8731 51.2823 60.5756 52.0925 58.8367 52.0925L58.7851 53.1246H57.5002L57.4354 51.0734H57.8637C59.3302 51.0734 60.4592 50.8123 60.4592 49.4405C60.4592 48.5261 59.9011 47.9644 58.9668 47.9644C58.0456 47.9644 57.4617 48.4867 57.4617 49.4013H56.0734C56.0595 47.8209 57.1887 46.7103 58.9534 46.7103ZM58.1228 56.0118C57.5906 56.0118 57.1756 55.5937 57.1756 55.0584C57.1756 54.5226 57.5909 54.1047 58.1228 54.1047C58.6419 54.1047 59.0572 54.5228 59.0572 55.0584C59.0574 55.5937 58.6421 56.0118 58.1228 56.0118Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.7834 59.0209H46.7949V60.9664H68.7834V59.0209Z",
    fill: "#11274B"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M68.7834 59.0209H46.7949V60.9664H68.7834V59.0209Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.9508 59.0209H68.7837V60.9664H76.9508V59.0209Z",
    fill: "#11274B"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M76.9508 59.0209H68.7837V60.9664H76.9508V59.0209Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.3477 60.9666H60.0225V97.5736H61.3477V60.9666Z",
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M61.3477 60.9666H60.0225V97.5736H61.3477V60.9666Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M61.3477 61.8776L60.0225 62.4293V60.9666H61.3477V61.8776Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.1632 98.7579H54.2056V98.751C54.2056 97.6896 55.0603 96.8293 56.1144 96.8293H65.2541C66.3085 96.8293 67.163 97.6896 67.163 98.751V98.7579H67.1632Z",
    fill: "#11274B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.3843 79.2416C21.3843 79.2416 22.9868 78.6531 23.4016 80.3614C23.8164 82.0697 25.0038 81.6287 25.2285 81.2545C25.6715 80.5169 25.7335 77.8479 24.9717 77.6872C24.062 77.4948 21.705 78.4636 21.3843 79.2416Z",
    fill: "#475569"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.3843 79.2416C21.3843 79.2416 22.9868 78.6531 23.4016 80.3614C23.8164 82.0697 25.0038 81.6287 25.2285 81.2545C25.6715 80.5169 25.7335 77.8479 24.9717 77.6872C24.062 77.4948 21.705 78.4636 21.3843 79.2416Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M24.9702 77.6885C23.0907 77.7159 22.5935 79.3774 22.2916 80.842L21.6807 79.6941L22.1139 81.7314C22.0674 81.954 22.0188 82.1596 21.9629 82.3383C21.5105 83.7812 20.1151 84.2207 20.1151 84.2207C20.1151 84.2207 20.0308 83.6349 19.9567 82.8119V82.8112L20.6405 81.7283L19.8973 82.0426C19.8142 80.7517 19.8029 79.1995 20.1151 78.3146C20.7187 76.6063 22.3378 77.1319 22.3378 77.1319L24.9702 77.6885Z",
    fill: "#475569"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.6548 75.8968C29.6548 75.8968 28.6697 75.5981 27.6375 77.0166C26.6428 78.3834 26.2463 78.5439 25.572 78.0123C24.8978 77.4808 25.3056 74.5031 26.0671 74.3422C26.9771 74.15 29.3343 75.1186 29.6548 75.8968Z",
    fill: "#475569"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.6548 75.8968C29.6548 75.8968 28.6697 75.5981 27.6375 77.0166C26.6428 78.3834 26.2463 78.5439 25.572 78.0123C24.8978 77.4808 25.3056 74.5031 26.0671 74.3422C26.9771 74.15 29.3343 75.1186 29.6548 75.8968Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M32.822 83.6567C32.822 83.6567 31.5963 83.2707 30.7563 82.1096L31.8428 79.542L30.353 81.4119C30.2903 81.2725 30.2337 81.1255 30.1849 80.97C29.5391 78.911 29.6712 74.4411 25.958 74.3869L29.6496 73.5392C29.6496 73.5392 31.9606 72.7886 32.8215 75.2269C33.041 75.847 33.1485 76.6976 33.187 77.6208L31.8425 76.3682C31.8425 76.3682 32.7748 77.7297 33.2035 78.2984C33.2253 80.8511 32.822 83.6567 32.822 83.6567Z",
    fill: "#475569"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.2593 71.938C20.2593 71.938 21.8618 71.3495 22.2766 73.0578C22.6914 74.766 24.7782 75.4181 24.9923 74.5833C25.2207 73.6926 24.7158 70.5195 23.9542 70.3585C23.0443 70.1664 20.5797 71.1597 20.2593 71.938Z",
    fill: "#475569"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.2593 71.938C20.2593 71.938 21.8618 71.3495 22.2766 73.0578C22.6914 74.766 24.7782 75.4181 24.9923 74.5833C25.2207 73.6926 24.7158 70.5195 23.9542 70.3585C23.0443 70.1664 20.5797 71.1597 20.2593 71.938Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M24.0203 70.3687C20.9846 70.4131 20.4757 73.4435 20.0378 75.6733L18.491 73.4269C18.5107 73.4919 19.331 76.172 19.6481 77.2346C18.933 79.1114 17.0909 79.6928 17.0909 79.6928C17.0909 79.6928 16.5751 76.1061 16.7408 73.3529C17.1932 72.976 17.9931 72.3007 17.9931 72.3007L16.8075 72.5962C16.8674 72.0911 16.9592 71.6354 17.0909 71.2625C17.9517 68.8249 20.2634 69.5753 20.2634 69.5753L24.0203 70.3687Z",
    fill: "#475569"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.2307 85.2973C25.2267 85.2973 25.2229 85.2971 25.2187 85.2966C25.1607 85.29 25.1187 85.2373 25.1253 85.1789C26.1765 75.761 23.5428 67.8199 23.516 67.741C23.497 67.6852 23.5268 67.6247 23.582 67.6058C23.6378 67.5874 23.6977 67.6169 23.7162 67.6725C23.7432 67.7521 26.3918 75.7383 25.3356 85.2028C25.3295 85.2572 25.2837 85.2973 25.2307 85.2973Z",
    fill: "#475569"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.3143 84.6125H21.1895V85.7579H29.3143V84.6125Z",
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M29.3143 84.6125H21.1895V85.7579H29.3143V84.6125Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.0038 85.7568H22.4589C21.7929 87.3138 19.6401 91.9022 19.6401 93.2578C19.6401 94.8614 21.6267 98.2037 21.6267 98.2037C21.6267 98.4436 28.8357 98.4436 28.8357 98.2037C28.8357 98.2037 30.8223 94.8614 30.8223 93.2578C30.8223 91.9022 28.6695 87.3138 28.0038 85.7568Z",
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.6942 21.8732C39.4229 21.8732 41.635 19.6463 41.635 16.8992C41.635 14.1521 39.4229 11.9252 36.6942 11.9252C33.9655 11.9252 31.7534 14.1521 31.7534 16.8992C31.7534 19.6463 33.9655 21.8732 36.6942 21.8732Z",
    fill: "#11274B"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.6942 21.8732C39.4229 21.8732 41.635 19.6463 41.635 16.8992C41.635 14.1521 39.4229 11.9252 36.6942 11.9252C33.9655 11.9252 31.7534 14.1521 31.7534 16.8992C31.7534 19.6463 33.9655 21.8732 36.6942 21.8732Z",
    fill: "#EEF7FD"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M36.6953 21.976C33.9148 21.976 31.6528 19.6988 31.6528 16.8996C31.6528 14.1004 33.9148 11.8232 36.6953 11.8232C39.4758 11.8232 41.7377 14.1004 41.7377 16.8996C41.7377 19.6988 39.4758 21.976 36.6953 21.976ZM36.6953 12.0279C34.027 12.0279 31.8561 14.2134 31.8561 16.8996C31.8561 19.5859 34.027 21.7713 36.6953 21.7713C39.3636 21.7713 41.5344 19.5859 41.5344 16.8996C41.5344 14.2134 39.3636 12.0279 36.6953 12.0279Z",
    fill: "#11274B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.7349 14.1359C37.8049 14.1359 38.5318 14.7711 38.5318 15.8162C38.5318 16.9497 37.7333 17.4484 36.6631 17.4484L36.6311 18.0837H35.8405L35.8005 16.8214H36.0639C36.9664 16.8214 37.6613 16.6607 37.6613 15.8165C37.6613 15.2538 37.3178 14.908 36.7429 14.908C36.1759 14.908 35.8165 15.2294 35.8165 15.7924H34.962C34.954 14.8191 35.6489 14.1359 36.7349 14.1359ZM36.2238 19.86C35.8963 19.86 35.6407 19.6027 35.6407 19.2732C35.6407 18.9435 35.8963 18.6861 36.2238 18.6861C36.5433 18.6861 36.799 18.9435 36.799 19.2732C36.799 19.6029 36.5433 19.86 36.2238 19.86Z",
    fill: "#11274B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.7861 20.78L41.3973 21.5864C41.4818 21.6287 41.5738 21.5444 41.5398 21.4557L40.8348 19.6154C40.4761 20.1285 40.1256 20.5298 39.7861 20.78Z",
    fill: "#11274B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_522_210"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 118,
    height: 108.229,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileIn);
export default __webpack_public_path__ + "static/media/mobile-in.bfb887e132135b1905f5410271e0ea93.svg";
export { ForwardRef as ReactComponent };